import React from 'react';
import { Link } from 'react-router-dom';

const Terms = () => {
  return (
    <div className="legal-page">
      <h1>Terms of Service</h1>
      <p className="last-updated">Last Updated: January 2024</p>

      <h2>1. Acceptance of Terms</h2>
      <p>By inviting and using Raix ("the Bot"), you agree to be bound by these Terms of Service ("Terms"). If you do not agree to these Terms, please do not use the Bot.</p>

      <h2>2. Description of Service</h2>
      <p>Raix is an all-in-one Discord bot that provides moderation, entertainment, utility, and other features to enhance your Discord server experience. The Bot is provided "as is" and we reserve the right to modify, suspend, or discontinue any aspect of the service at any time.</p>

      <h2>3. User Obligations</h2>
      <p>By using Raix, you agree to:</p>
      <ul>
        <li>Comply with Discord's Terms of Service and Community Guidelines</li>
        <li>Use the Bot only for lawful purposes</li>
        <li>Not attempt to exploit, hack, or abuse the Bot</li>
        <li>Not use the Bot to harass, spam, or harm other users</li>
      </ul>

      <h2>4. Intellectual Property</h2>
      <p>All rights, title, and interest in and to Raix, including all associated intellectual property rights, are and will remain the exclusive property of the developers (RaiMohan and RaiSunny).</p>

      <h2>5. Contact Information</h2>
      <p>For questions about these Terms, please contact us at:</p>
      <p>Email: <a href="mailto:factsonly9667@gmail.com">factsonly9667@gmail.com</a><br/>
      Discord: <a href="https://discord.gg/5tUh6aktZw" target="_blank" rel="noopener noreferrer">Join our support server</a></p>

      <div style={{ marginTop: '4rem' }}>
        <Link to="/" className="btn-secondary">Back to Home</Link>
      </div>
    </div>
  );
};

export default Terms;
